var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.rootStyle,attrs:{"href":_vm.url,"target":_vm.target}},[_c('div',{staticClass:"c-panel-brand__content"},[_c('img',{attrs:{"src":_vm.image}})])])}
var staticRenderFns = []

export { render, staticRenderFns }